/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import NotificationPlugin from './plugins/NotificationPlugin';
import BootstrapVue from 'bootstrap-vue';
import route from 'ziggy-js';
import { Ziggy } from 'ziggy-js';
import HighchartsVue from 'highcharts-vue'

require('./bootstrap');

window.Vue = require('vue');
require('./helpers/inputHover');
require('./helpers/custom');

Vue.prototype.$globalEvents = new Vue();


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
Vue.config.ignoredElements = ['ion-icon'];
Vue.config.ignoredElements = [/^ion-/];


Vue.component('main-layout', require('./containers/Layouts/Main/MainLayout.vue').default);
Vue.component('main-sidebar', require('./containers/Layouts/Main/components/Sidebar.vue').default);
Vue.component('app-button', require('./components/Button.vue').default);
Vue.component('app-icon-button', require('./components/IconButton.vue').default);
Vue.component('progress-bar', require('./components/ProgressBar.vue').default);
Vue.component('dropdown', require('./components/Dropdown.vue').default);
Vue.component('date-picker', require('./components/Form/DatePicker.vue').default);
Vue.component('text-editor', require('./components/Form/TextEditor.vue').default);
Vue.component('breadcrumbs', require('./components/BreadCrumbs.vue').default);
Vue.component('intelliboard-icon', require('./components/IntelliboardIcon.vue').default);
Vue.component('table-search-input', require('./components/TableSearchInput.vue').default);
Vue.component('table-search-select', require('./components/TableSearchSelect.vue').default);
Vue.component('form-fieldset', require('./components/Form/Fieldset.vue').default);
Vue.component('form-input', require('./components/Form/FormInput.vue').default);
Vue.component('help-block', require('./components/Form/HelpBlock.vue').default);
Vue.component('app-link', require('./components/Link.vue').default);
Vue.component('app-label', require('./components/Form/Label.vue').default);
Vue.component('input-field', require('./components/Form/InputField.vue').default);
Vue.component('iconed-input-field', require('./components/Form/IconedInputField.vue').default);
Vue.component('app-input', require('./components/Form/Input.vue').default);
Vue.component('slug-input', require('./components/Form/SlugInput.vue').default);
Vue.component('tag-input', require('./components/Form/TagInput.vue').default);
Vue.component('app-input-avatar', require('./components/Form/InputAvatar.vue').default);
Vue.component('password-input', require('./components/Form/PasswordInput.vue').default);
Vue.component('app-textarea', require('./components/Form/Textarea.vue').default);
Vue.component('app-checkbox', require('./components/Form/AppCheckbox.vue').default);
Vue.component('app-checkbox-set', require('./components/Form/CheckboxSet.vue').default);
Vue.component('app-select', require('./components/Form/Select.vue').default);
Vue.component('colorpicker', require('./components/Form/Colorpicker.vue').default);
Vue.component('form-panel', require('./components/Form/FormPanel.vue').default);
Vue.component('button-set', require('./components/ButtonSet.vue').default);
Vue.component('tabs', require('./components/Tabs/Tabs.vue').default);
Vue.component('tab', require('./components/Tabs/Tab.vue').default);
Vue.component('timer', require('./components/Timer.vue').default);
Vue.component('panel', require('./components/Panel.vue').default);
Vue.component('loader', require('./components/Loader.vue').default);
Vue.component('full-page-loader', require('./components/FullPageLoader.vue').default);
Vue.component('block-loader', require('./components/BlockLoader.vue').default);
Vue.component('loader-dots', require('./components/LoaderDots.vue').default);
Vue.component('toggle', require('./components/Toggle.vue').default);
Vue.component('status-icon', require('./components/StatusIcon.vue').default);
Vue.component('column-chart', require('./components/Monitors/ColumnChart.vue').default);
Vue.component('line-chart', require('./components/Monitors/LineChart.vue').default);
Vue.component('timeline', require('./components/Monitors/TimeLine.vue').default);
Vue.component('monitor', require('./components/Monitor.vue').default);
Vue.component('report', require('./components/Monitors/Report/Index.vue').default);
Vue.component('separator', require('./components/Separator.vue').default);
Vue.component('modal', require('./components/Modal.vue').default);
Vue.component('loading-overlay', require('./components/LoadingOverlay.vue').default);
Vue.component('password-input-validation', require('./components/Form/ValidationPaswordInput.vue').default);

Vue.component('user-logs-table', require('./containers/Analytics/UserLogs/Table').default);
Vue.component('failed-lms-task-logs-table', require('./containers/Analytics/FailedLmsTaskLogs/Table').default);
Vue.component('user-logins-table', require('./containers/Analytics/UserLogins/Table').default);
Vue.component('user-logins-chart', require('./components/Admin/Chart.vue').default);
Vue.component('tracking-by-active-users-table', require('./containers/Analytics/TrackingByActiveUsers/Table').default);
Vue.component('analytics-table', require('./containers/Analytics/Table').default);

Vue.component('login-as-logs-date-filter', require('./containers/Analytics/LoginAsLogs/DateFilter').default);

Vue.component('admin-translations-table', require('./components/Admin/TranslationsTable.vue').default);
Vue.component('admin-translation-row', require('./components/Admin/TranslationRow.vue').default);
Vue.component('admin-users-search', require('./components/Admin/UsersSearch.vue').default);
Vue.component('admin-analytics-search', require('./components/Admin/AnalyticsSearch.vue').default);
Vue.component('admin-companies-search', require('./components/Admin/CompaniesSearch.vue').default);
Vue.component('admin-job-in-progress-search', require('./components/Admin/JobInProgressSearch.vue').default);
Vue.component('admin-prospect-select-user', require('./components/Admin/ProspectUserSelect.vue').default);
Vue.component('admin-actions-dropdown', require('./components/Admin/ActionsDropdown.vue').default);

Vue.component('permission-list', require('./containers/Permissions/PermissionList.vue').default);
Vue.component('dashboard-subscriptions-chart', require('./components/Dashboard/DashboardChart.vue').default);
Vue.component('connection-chart', require('./components/Connection/Chart.vue').default);
Vue.component('crawler-instance-chart', require('./components/Connection/CrawlerInstanceChart.vue').default);
Vue.component('crawler-instance-size-chart', require('./components/Connection/CrawlerInstanceSizeChart.vue').default);
Vue.component('dashboard-connection-status-chart', require('./components/Dashboard/StatusConnectionChart.vue').default);
Vue.component('screen-mode-theme', require('./components/CheckboxDarkMode.vue').default);
Vue.component('accordion', require('./components/Accordion.vue').default);
Vue.component('setup-page', require('./components/SetupPage/setup.vue').default);
Vue.component('library-backups-table', require('./containers/Library/BackupsTable').default);
Vue.component('library-local-backups-table', require('./containers/Library/LocalBackupsTable').default);
Vue.component('statistics-processing-success-chart', require('./components/Connection/Statistics/ProcessingSuccessChart.vue').default);
Vue.component('statistics-processing-errors-chart', require('./components/Connection/Statistics/ProcessingErrorsChart.vue').default);
Vue.component('connection-process-history-table', require('./components/Connection/JobsProcess/ProcessHistoryTable.vue').default);
Vue.component('targeted-refetch-modal', require('./components/Connection/TargetedRefetchModal.vue').default);
Vue.component('data-sets-index', require('./containers/Builder/DataSet/Index.vue').default);
Vue.component('data-sets-confirm-delete', require('./containers/Builder/DataSet/ConfirmDelete.vue').default);

Vue.component('auth-sidebar', require('./containers/Auth/AuthSidebar.vue').default);
Vue.component('two-factor-code-input', require('./containers/Auth/TwoFactorCode.vue').default);
Vue.component('app-selected-folder', require('./components/SelectedFolder.vue').default);
Vue.component('error-modal', require('./components/ErrorModal').default);
Vue.component('terminal-modal', require('./components/TerminalModal').default);
Vue.component('run-connection-modal', require('./components/RunConnectionModal').default);
Vue.component('import-translations-modal', require('./components/ImportTranslationsModal').default);
Vue.component('export-translations-modal', require('./components/ExportTranslationsModal').default);

Vue.component('tasklog-table', require('./components/Logs/TasklogTable').default);
Vue.component('adhoc-tasks-table', require('./components/PluginData/AdhocTasksTable.vue').default);
Vue.component('running-tasks-table', require('./components/PluginData/RunningTasksTable.vue').default);
Vue.component('exportlog-table', require('./components/Logs/ExportlogTable').default);
Vue.component('datatypes-table', require('./components/PluginData/DatatypesTable').default);
Vue.component('reset-migration-button', require('./components/Logs/ResetMigrationButton').default);
Vue.component('processing-logs-table', require('./components/Connection/JobsProcess/TestLogTable').default);

Vue.component('tutorials-table', require('./components/PlatformMenu/TutorialsTable').default);
Vue.component('tutorial-clips', require('./components/PlatformMenu/TutorialClips.vue').default);
Vue.component('icons-select', require('./components/PlatformMenu/IconsSelect.vue').default);
Vue.component('release-note-form', require('./components/PlatformMenu/ReleaseNoteForm.vue').default);
Vue.component('login-template', require('./containers/Auth/AuthError.vue').default);
Vue.component('in-platform-notification-form', require('./components/PlatformMenu/InPlatformNotification').default);

Vue.component('image-login-page', require('./components/ImageLoginPage').default);


Vue.component('dynamic-table-relation-form', require('./containers/DynamicTables/Relations/Form').default);
Vue.component('dynamic-tables', require('./containers/DynamicTables/Relations/Index').default);

// Companies
Vue.component('companies-show-page', require('./containers/Companies/Show').default);
Vue.component('companies-form', require('./containers/Companies/Form.vue').default);
Vue.component('ib-storage-client', require('./containers/IbStorage/Client.vue').default);
Vue.component('company-enable-two-fa-action', require('./components/Admin/CompanyEnableTwoFaAction.vue').default);

// Users
Vue.component('users-form', require('./containers/Users/Form.vue').default);
Vue.component('users-table', require('./containers/Users/UsersTable.vue').default);
Vue.component('users-rft-account', require('./containers/Users/RFTAccount.vue').default);

// LMS Connections
Vue.component('lms-connection-form', require('./containers/LmsConnections/Form.vue').default);

// Default Reports
Vue.component('default-reports', require('./components/Reports/DefaultReports.vue').default);

// Metadata
Vue.component('master-tables-tool', require('./components/MetaData/MasterTablesTool/Index').default);
Vue.component('master-tables-view', require('./components/MetaData/MasterTables/Index').default);
Vue.component('platform-fields', require('./components/MetaData/PlatformFields/Index').default);
Vue.component('platform-edit-mode', require('./components/MetaData/PlatformFields/EditMode').default);
Vue.component('metadata-dynamic-table-form', require('./containers/MetaData/DynamicTableForm').default);
Vue.component('metadata-dynamic-table-column-form', require('./containers/MetaData/DynamicTableColumnForm').default);
Vue.component('metadata-dynamic-table-column-index-filters', require('./containers/MetaData/DynamicTableColumnIndexFilters').default);
Vue.component('metadata-platform-table', require('./components/MetaData/PlatformTable/Form.vue').default);
Vue.component('enum-editor', require('./components/MetaData/ColumnSettings/Enum.vue').default);

// Translations
Vue.component('sources-select', require('./components/Translations/SourcesSelect.vue').default);
Vue.component('translation-add-form', require('./components/Translations/AddForm.vue').default);
Vue.use(NotificationPlugin);
Vue.use(BootstrapVue);
Vue.use(HighchartsVue);

Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
        goto: (name, params, absolute) => {
            window.location.href = self.route(name, params, absolute)
        },
    },
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app'
});
